export default __webpack_public_path__ + "static/media/logo-unilab-preto.a77c4d9f.png";